import { render } from "./OddsCompanyFilter.vue?vue&type=template&id=0b6b9cfb&scoped=true"
import script from "./OddsCompanyFilter.vue?vue&type=script&lang=js"
export * from "./OddsCompanyFilter.vue?vue&type=script&lang=js"

import "./OddsCompanyFilter.vue?vue&type=style&index=0&id=0b6b9cfb&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6b9cfb"]])

export default __exports__